import { gql } from '@apollo/client';

const DELETE_COURSE_MUTATION = gql`
    mutation deleteCourse( $courseID: UUID! ) {
        result: deleteCourse( courseID: $courseID ) {
            affectedRows
        }
    }
`;

export default DELETE_COURSE_MUTATION;
